import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Language, LanguageCode, ProductPlatformGroup } from '@mkp/shared/models';
import { HeaderItem } from '@mkp/layout/models';
import { User } from '@mkp/user/models';

export interface TopHeaderViewModel {
  activePlatformGroup: string | undefined;
  hasAccountMembership: boolean;
  showNavigation: boolean;
  isBoUser: boolean | null;
  isMobile: boolean;
  isLight: boolean;
  isNavCollapsed: boolean | undefined;
  isActiveUser: boolean;
  languages: { options: Language[]; selected: LanguageCode };
  platformClasses: ProductPlatformGroup[];
  user: User | null | undefined;
  itemsConfig: Record<string, Record<string, unknown>>;
  usernamePasswordLoginPreferred: boolean;
}

export interface TopHeaderStoreInterface {
  readonly leftBoxItems$: Observable<HeaderItem[] | undefined>;
  readonly rightBoxItems$: Observable<HeaderItem[] | undefined>;
  readonly vm$: Observable<TopHeaderViewModel>;

  toggleNavCollapsed(): void;
  changeLanguage(language: Language): void;
}

export const TOP_HEADER_STORE = new InjectionToken<TopHeaderStoreInterface>('TopHeaderStore');
